import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import globals from '#utilities/js/ea/globals.js'

// @todo Suppression de ce listener lorsque le menu Help ("?") sera passé en fragments

const onClick = object(listener, {
  type: click,
  passive,
  task: async () => {
    globals.ea_context_menu_close()
  }
})

export default async (
  li
) => {
  onClick.listen(li)
}
